var map = {
	"./catchout.png": 411,
	"./caught.png": 412,
	"./cleanbowled.png": 413,
	"./four.png": 414,
	"./lbw.png": 415,
	"./lbwout.png": 416,
	"./run_out.png": 417,
	"./runout.png": 418,
	"./six.png": 419,
	"./stumped.png": 420,
	"./stumpout.png": 421,
	"./wicket.png": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 410;